import React from "react";
import { useEffect } from "react";

interface Props extends React.HTMLProps<HTMLInputElement> {
    initialValue?: string;
    onChangeHandler: (value: string) => void;
}

const SmartUpdateInput: React.FC<Props> = ({
    onChangeHandler,
    initialValue = "",
    ...rest
}) => {
    const [value, setValue] = React.useState<string>(initialValue);

    useEffect(() => setValue(initialValue), [initialValue]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setValue(e.target.value);
    };

    const handleBlur = () => {
        onChangeHandler(value);
    };

    return (
        <input
            onChange={handleChange}
            onBlur={handleBlur}
            value={value}
            {...rest}
        />
    );
};

export default SmartUpdateInput;
